import React from 'react';
import styles from './style.module.scss';
import ReviewHeader from '../common/ReviewHeader';
import processorPlaceholderImg from '../../../../../../../../../../images/paychex-logo.png';

const Processor = ({ formik, onEdit, isOpen, onToggle }) => {
  const { values } = formik;

  const ProcessorItem = ({ logo, name }) => (
    <div className={styles.processorItem}>
      <div className={styles.processorContent}>
        <div className={styles.processorLogo}>
          <img src={logo} alt={name} />
        </div>
        <div className={styles.processorName}>{name || '-'}</div>
      </div>
    </div>
  );

  return (
    <div className={styles.processor}>
      <ReviewHeader
        title="Processor"
        isOpen={isOpen}
        onToggle={onToggle}
        onEdit={onEdit}
      />

      {isOpen && (
        <div className={styles.content}>
          <div className={styles.processorList}>
            <ProcessorItem
              logo={processorPlaceholderImg}
              name="Beyond"
            />
            <ProcessorItem
              logo={processorPlaceholderImg}
              name="Payarc"
            />
            {values.additional_processors?.map((processor, index) => (
              <ProcessorItem
                key={index}
                logo={processor.logo}
                name={processor.name}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Processor; 